import { useEffect, useState, useContext } from 'react'
import {
  Button,
  Modal,
  CloseButton,
  Placeholder,
  Card,
  Row,
} from 'react-bootstrap'
import DataCollection from './DataCollection'
import DetailedInfo from './DetailedInfo'
import axios from 'axios'
import { AuthContext } from '../AuthContext'
import dayjs from 'dayjs'

const MetabolicPlanBasicInfo = ({
  basicInfoModalShow,
  setBasicInfoModalShow,
  currentPatient,
  setCurrentPatient,
  setCaseModalShow,
  setQrcode,
  caseModalShow,
}) => {
  const { patient_id } = currentPatient
  const [dataCollectionModalShow, setDataCollectionModalShow] = useState(false)
  const [detailInfoModalShow, setDetailInfoModalShow] = useState(false)
  const [currentPatientInfo, setCurrentPatientInfo] = useState({
    name: '',
    gender: 0,
    birthday: '',
    phone: '',
    id_number: '',
    linked_ha_app: 0,
    status: 0,
  })
  const [isCardLoading, setIsCardLoading] = useState(false)

  const { name, gender, birthday, phone, id_number, linked_ha_app, status } =
    currentPatientInfo
  const { baseUrl, sendDiscordNotification, currentUser, extendCookie } =
    useContext(AuthContext)
  const getPatientInfo = '/api/crm/project/patient/getPatientInfo'

  const age = dayjs().diff(birthday, 'year')

  // TODO 結案之後要更新 basicinfo
  useEffect(() => {
    if (currentUser && currentUser.session) {
      let loadingTimer

      setIsCardLoading(true)

      axios
        .post(
          baseUrl + getPatientInfo,
          { project_id: 'P0001', patient_id: patient_id },
          {
            headers: {
              'Content-Type': 'application/json; charset=UTF-8',
              Accept: '*/*',
              session: currentUser.session,
            },
          }
        )
        .then((res) => {
          if (res.data) {
            console.log('getPatientInfo', res.data)
            setCurrentPatientInfo(res.data)
            extendCookie()
          }
        })
        .catch((e) => {
          console.log('getPatientInfo error', e)
          sendDiscordNotification(`getPatientInfo Error \n Error: ${e} `)
          alert('伺服器忙線中，請稍後再試')
        })
        .finally(() => {
          setIsCardLoading(false)
          clearTimeout(loadingTimer)
        })
    }
  }, [currentUser, caseModalShow])

  return (
    <>
      {/* 數據紀錄 */}
      {dataCollectionModalShow && (
        <DataCollection
          patient_id={patient_id}
          dataCollectionModalShow={dataCollectionModalShow}
          setDataCollectionModalShow={setDataCollectionModalShow}
        />
      )}

      {/* 詳細資料 */}
      {detailInfoModalShow && (
        <DetailedInfo
          detailInfoModalShow={detailInfoModalShow}
          setDetailInfoModalShow={setDetailInfoModalShow}
          currentPatient={currentPatient}
          setQrcode={setQrcode}
          patient_id={patient_id}
          status={status}
        />
      )}

      <Modal
        show={basicInfoModalShow}
        onHide={() => {
          setCurrentPatient(null)
          setBasicInfoModalShow(false)
        }}
        // dialogClassName="basicInfoModalWidth"
        // size="sm"
        centered
        className="basicInfoModal"
      >
        <CloseButton
          onClick={() => {
            setCurrentPatient(null)
            setBasicInfoModalShow(false)
          }}
          className="position-absolute"
          style={{ top: '10px', right: '10px' }}
        />

        <div className="basicInfoModalContent d-flex flex-column align-items-center p-3">
          <svg
            width="102"
            height="102"
            viewBox="0 0 102 102"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_558_947)">
              <rect
                x="1"
                y="1"
                width="100"
                height="100"
                rx="50"
                fill={gender ? '#94B2D5' : '#E7AE9D'}
              />
              <rect
                x="32.8389"
                y="16.6953"
                width="36.7713"
                height="36.7713"
                rx="18.3857"
                fill="white"
              />
              <rect
                x="15.3501"
                y="57.9502"
                width="71.7489"
                height="67.2646"
                rx="33.6323"
                fill="white"
              />
            </g>
            <rect
              x="1"
              y="1"
              width="100"
              height="100"
              rx="50"
              stroke={gender ? '#6F93BC' : '#D98471'}
              strokeWidth="1.34529"
            />
            <defs>
              <clipPath id="clip0_558_947">
                <rect
                  x="1"
                  y="1"
                  width="100"
                  height="100"
                  rx="50"
                  fill="white"
                />
              </clipPath>
            </defs>
          </svg>
          {isCardLoading ? (
            <div className="w-75 text-center">
              {' '}
              <Placeholder as={Card.Title} animation="glow">
                <Placeholder xs={6} />
              </Placeholder>
              <Placeholder as={Card.Text} animation="glow" className="my-3">
                <Placeholder xs={7} /> <Placeholder xs={4} />{' '}
                <Placeholder xs={4} /> <Placeholder xs={6} />{' '}
                <Placeholder xs={8} />
              </Placeholder>
              <Row className="justify-content-center">
                <Placeholder.Button variant="primary" xs={3} className="me-3" />
                <Placeholder.Button variant="primary" xs={3} />
              </Row>
            </div>
          ) : (
            <>
              <h4 className="my-3">{name}</h4>
              <p>
                {gender ? '男' : '女'} | {birthday}({age} 歲)
              </p>
              <p>身分證： {id_number}</p>
              <p>電話： {phone}</p>
              <div>
                App 串接狀態：
                {linked_ha_app ? (
                  <span className="integrated">已串接</span>
                ) : (
                  <span className="unIntegrated">未串接</span>
                )}
              </div>
              <div className="d-flex mt-4 mb-3">
                <Button
                  variant="outline-primary me-3"
                  onClick={() => {
                    setDataCollectionModalShow(true)
                  }}
                >
                  數據收集紀錄
                </Button>
                {status === 3 || status === 2 ? (
                  <Button variant="secondary" className="text-white" disabled>
                    已結案
                  </Button>
                ) : (
                  <Button
                    variant="primary"
                    className="text-white"
                    onClick={() => {
                      setCaseModalShow(true)
                    }}
                  >
                    計劃追蹤
                  </Button>
                )}
              </div>
            </>
          )}
        </div>
        <Modal.Footer
          className="justify-content-center basicInfoModalFooter"
          onClick={() => {
            setDetailInfoModalShow(true)
          }}
          style={{ cursor: 'pointer' }}
        >
          詳細資料
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default MetabolicPlanBasicInfo
